module.exports = __webpack_public_path__ + "public/images/animals.cad9df471e072c8df6c3c35b2d318eb0.png";